import React from 'react'

const Count = () => {
  return (
    <div className='section count'>
      <div className='heading-inverse' data-aos='fade-up' data-aos-delay='200'>
        We Are Doing Our Part
      </div>
      <p
        className='sub-heading-inverse col-lg-6 col-md-10'
        data-aos='fade-up'
        data-aos-delay='500'
      >
        Rean is a Triple Bottom Line ethos company, committed to cater to
        bottom of pyramid population of India with potable piped water supply in
        association with various Government organisations. Focused specially on
        population where piped water has not been available ever! Rean's
        relentless efforts lead to improved health in the populations catered.
        {/* <a href='#'>Read More</a> */}
      </p>
      <div className='container row numbers'>
        <div className='col-lg-3' data-aos='fade-up' data-aos-delay='600'>
          <h1>1 Million +</h1>
          <p>Lives touched and counting...</p>
        </div>
        <div className='col-lg-3' data-aos='fade-up' data-aos-delay='900'>
          <h1>150 +</h1>
          <p>Brilliant Minds On-Board</p>
        </div>
        <div className='col-lg-3' data-aos='fade-up' data-aos-delay='700'>
          <h1>$200 Mln.</h1>
          <p>Massive order book</p>
        </div>
        <div className='col-lg-3' data-aos='fade-up' data-aos-delay='800'>
          <h1>25 +</h1>
          <p>Projects with Major Impact</p>
        </div>
      </div>
    </div>
  )
}

export default Count
